import React from 'react';
import { Route, Router } from 'react-router-dom';
import App from './App';
import Callback from './Callback/Callback';
import Auth from './Auth/Auth';
import history from './history';
import DashBoard from './DashBoard/DashBoard';
import ViewSpace from './ViewSpace/ViewSpace';
import Library from './Library/Library';
import FeaturedSpace from './FeaturedSpace/FeaturedSpace';

const auth = new Auth();

const handleAuthentication = (nextState, replace) => {
  if (/access_token|id_token|error/.test(nextState.location.hash)) {
    auth.handleAuthentication();
  }
}

export const makeMainRoutes = () => {
  return (
    <Router history={history} component={App}>
          <div>
            <Route path="/" render={(props) => <App auth={auth} {...props} />} />
            <Route path="/callback" render={(props) => {
              handleAuthentication(props);
              return <Callback {...props} />
            }}/>
            <Route path="/dash" render={(props) => <DashBoard auth={auth} {...props} />} />
            <Route path="/spaces" render={(props) => <Library auth={auth} {...props} />} />
            <Route path="/view-spaces/:id" render={(props) => <ViewSpace auth={auth} {...props} />} />
            {/* <Route path="/featured-spaces/:id" render={(props) => <FeaturedSpace auth={auth} {...props} />} /> */}
          </div>
      </Router>
  );
}



// WEBPACK FOOTER //
// ./src/routes.js